// ==============================
// 1) EXACT UTILITY FROM YOUR CODE
// ==============================
const mapToOptions = (map) => {
  return Object.entries(map).map(([value, label]) => ({
    value: parseInt(value, 10),
    label: label,
  }));
};

// ==============================
// 2) DISPATCH CLASS MAP
// ==============================
const dispatchClassMap = {
  1: "Shut Down",
  2: "Off Level",
  3: "Door Trouble",
  4: "Indicator Problem",
  5: "Meet Contractor",
  6: "Meet At Site",
  7: "Provide Access",
  8: "Survey Elevator",
  9: "Oil Leak",
  10: "Elevator Getting Stuck",
  11: "Elevator Skipping Floors",
  12: "Elevator Bouncing",
  13: "Maintenance",
  14: "Noise Complaint",
  15: "Follow-Up",
  16: "Shop Time",
  17: "Elevator Cab Lights Out",
  18: "Test / Inspections",
  19: "Repair Work",
  20: "Miscellaneous",
  21: "Elevator Phone",
  22: "Violations",
  23: "Company",
  24: "Proposal",
  25: "Button",
  26: "Intermittent Problem",
  27: "Controller",
  28: "Annual Brake Inspection",
  29: "CAT One Repairs",
  30: "DLM",
};

// ==============================
// 3) FULL DISPATCH SUB-CLASS MAP
//    (kept verbatim, no removals)
// ==============================
const dispatchSubClassMap = {
  1: {
    1: "Power Failure",
    2: "Left Shutdown",
    3: "Water Damage",
    4: "Stuck In Lobby",
    5: "Getting Stuck at Landing",
    6: "Car Not Running",
    7: "Smoke Condition",
    8: "Intermittent Problem",
    9: "Entrapment",
    10: "Cease Use",
  },
  2: {
    1: "Rest Floor Stops",
    2: "Tripping Hazard",
    3: "Car Stuck In Overhead",
    4: "Car Stuck In Pit",
  },
  3: {
    1: "Door Not Closing",
    2: "Door Slamming",
    3: "Door Recycling",
    4: "Door Jammed",
    5: "Interlock Hanging Up",
    6: "Car Door Off Track",
    7: "Hatch Door Off Track",
    8: "Door Not Opening At Landing",
    9: "Door Moving Very Slow",
    10: "Doors Not Engaging",
    11: "Detector Edge Defective",
    12: "Loose Bolt On Door Equipment",
  },
  4: {
    1: "PI Bulbs Out",
    2: "LED Display Inoperative",
    3: "Display In Car Out",
    4: "Display In Hall Out",
    5: "Roto Dial Inoperative",
  },
  5: {},
  6: {},
  7: {
    1: "Provide Pit Access",
    2: "Provide Access To Car Top For Outside",
    3: "Move Equipment On Car Top For Vendor",
  },
  8: {
    1: "Check PVT Items",
    2: "Check ECB Items",
    3: "Survey CAT 1 Deficiencies",
    4: "Check Completed Deficiency Items",
    5: "Maintenance Survey",
  },
  9: {
    1: "Oil Leaking Into Cab",
    2: "Oil Leaking On Motor Room Floor",
    3: "Oil Leaking Into Pit",
    4: "Cables Oily & Dirty",
  },
  10: {
    1: "Car Stuck In Basement",
    2: "Car Stuck In Overhead",
    3: "Car Getting Stuck Various Floors",
    4: "Sticking On Lobby Landing",
  },
  11: {},
  12: {
    1: "Elevator Releveling",
    2: "Elevator Stopping Hard",
  },
  13: {
    1: "Monthly Maintenance",
    2: "Pre Maintenance",
    3: "Special Request",
    4: "Clean & Paint Motor Room Equipment",
    5: "Extra Maintenance",
    6: "Perform Annual Brake Maintenance & T",
    7: "Covered Repair Maintenance Contract",
  },
  14: {
    1: "Elevator Scraping In Hoistway",
    2: "Motor Making Noise",
    3: "Fan In Car Making Noise",
    4: "Beeping Sound",
    5: "Elevator Has Excessive Play In Shoes",
    6: "Squeaking Noise In Shaft",
    7: "Car Door Making Noise",
    8: "Noise From Machine",
    9: "Car Rumbling At Top Floor",
    10: "Loud Banging At Top Floor",
  },
  15: {
    1: "Defective Keyswitch",
    2: "Phone In Cab Defective",
    3: "Unblock Landing",
    4: "Add Hydraulic Oil In Tank",
    5: "Add Oil To Machine",
    6: "Add Oil To Door Check",
    7: "More Repairs Needed",
    8: "Proposal Required",
    9: "Door Check Defective",
    10: "Replace Car Station Button",
    11: "Replace Hall Station Button",
    12: "Consultant Punch List Repairs",
  },
  16: {
    1: "Safety Class",
    2: "Picking Up Parts At Shop",
    3: "Mod Delivery To Shop",
    4: "Company App Training",
  },
  17: {
    1: "Bulbs In Cab Defective",
    2: '"AC" Traveler Broken',
  },
  18: {
    1: "Category (1) Inspection",
    2: "Category (5) Inspection",
    3: "CAT One & Cat Five Inspections",
    4: "Out of Borough Annual Inspection",
    5: "Six Month Inspection",
    6: "DOB Sign-Off",
    7: "Electrical Inspection For Mod",
    8: "CAR S/D During Test",
    9: "Annual Brake Maintenance & Tag",
  },
  19: {
    1: "Emergency Repairs",
    2: "Proposal Work",
    3: "Test Deficiency Repairs",
    4: "Reshackle Cables",
  },
  20: {
    1: "Keys In Pit",
    2: "Smoke In Motor Room",
    3: "Odor From Pit",
    4: "Water In Pit",
    5: "Water Leaking In Shaft",
    6: "Broken Vision Glass",
    7: "Meet DOB Inspector At Site",
    8: "Cab Handrail Loose",
    9: "Deliver Parts To Site",
    10: "Part Came Off Elevator",
    11: "Floor Lock-Out Inoperative",
    12: "Car Fan Not Working",
    13: "Consultant Inspection",
    14: "Running Slow",
    15: "Lights In Cab Going Out When Car Runs",
  },
  21: {
    1: "Cab Phone Inoperative",
    2: "Reprogram Phone For New Customer",
    3: "Phone Line Dead",
    4: "Reprogram Cab Phone",
  },
  22: {
    1: "ECB Repairs",
    2: "PVT Repairs",
    3: "Check Completed Items",
    4: "Survey Items",
    5: "CAT One Repairs",
    6: "CAT Five Shutdown Repairs",
    7: "Cease Use Items",
    8: "Alarm Bell Inoperative",
    9: "Car Door Restrictor Inoperative",
    10: "Covered CAT One Items",
    11: "Billable Items",
    12: "Periodic Violation Conditions",
  },
  23: {
    1: "Vacation",
    2: "Sick",
    3: "Bereavement",
    4: "Personal",
    5: "Shop",
    6: "Safety Classes",
    7: "Union En Lieu Day",
    8: "Holiday",
  },
  24: {
    1: "Emergency Repairs",
    2: "Repair Work",
    3: "Maintenance Work",
    4: "Violation Work",
    5: "CAT One Work",
    6: "CAT Five Work",
    7: "Modernization",
    8: "Door Lock Monitor Installation",
  },
  25: {
    1: "Damaged Car Call Button",
    2: "Damaged Hall Call Button",
    3: "Button Jammed In",
    4: "No Response To Call Button",
    5: "Replaced Door Open Button",
    6: "Replaced Door Close Button",
  },
  26: {
    1: "Drive Tripping",
    2: "Blowing Fuses",
    3: "Door Not Opening Right Away",
    4: "Getting Stuck At Same Landing",
  },
  27: {
    1: "Overhaul Relays",
    2: "Replace Relays",
  },
  28: [{ value: 1, label: "Perform & Tag Controller" }],
  29: [
    { value: 1, label: "Covered Items" },
    { value: 2, label: "Billable Items" },
    { value: 3, label: "Surveyed Items For Proposal" },
  ],
  30: [{ value: 1, label: "Survey For DLM" }],
};

// =============================================
// 4) CONVERT ANY OBJECT ENTRIES INTO ARRAYS
//    WITHOUT REMOVING ANY KEYS/FIELDS
// =============================================
const convertSubClassMapToArray = (maybeObjOrArray) => {
  if (Array.isArray(maybeObjOrArray)) {
    // Already an array of { value, label } => return as is
    return maybeObjOrArray;
  }
  // If it's an object like {1:"text", 2:"text2"} => convert it
  return Object.entries(maybeObjOrArray).map(([subKey, subLabel]) => ({
    value: parseInt(subKey, 10),
    label: subLabel,
  }));
};

// For each dispatch class, unify to an array of { value, label }
const unifiedSubClassOptions = Object.fromEntries(
  Object.entries(dispatchSubClassMap).map(([dispatchKey, subData]) => {
    return [dispatchKey, convertSubClassMapToArray(subData)];
  })
);

// Build final array of dispatchClass = { value, label } from the map
const dispatchClassOptions = mapToOptions(dispatchClassMap);

// ==============================
// 5) PROPOSAL CLASS MAP
// ==============================
const proposalClassMap = {
  1: "Emergency Proposal",
  2: "Maintenance Contract",
  3: "Modernization",
  4: "New Construction",
  5: "Other",
  6: "Repair Work",
  7: "Tests and Inspections",
  8: "Violation",
};

const proposalClassOptions = mapToOptions(proposalClassMap);

// ==============================
// 6) FIELDS (UNCHANGED)
// ==============================
export const agencyGeneralFields = [
  { key: "agencyId", label: "Agency ID", type: "number", isDisabled: true },
  {
    key: "agencyName",
    label: "Agency Name",
    type: "text",
  },
  {
    key: "agencyType",
    label: "Agency Type",
    type: "select",
    options: [
      { value: 1, label: "Primary Agency" },
      { value: 2, label: "Inspection Agency" },
      { value: 0, label: "Other" },
    ],
    map: { 0: "Other", 1: "Primary Agency", 2: "Inspection Agency" },
  },
];

export const agencyViolationsFields = [
  {
    key: "trackTest",
    label: "Track Tests",
    type: "checkbox",
    map: { false: "No", true: "Yes" },
  },
  {
    key: "trackViolation",
    label: "Track Violations",
    type: "checkbox",
    map: { false: "No", true: "Yes" },
  },
  {
    key: "useNYCViolations",
    label: "Use NYC Violations",
    type: "checkbox",
    map: { false: "No", true: "Yes" },
  },
  { key: "violationsList", label: "Violations List", type: "text" },
];

export const agencyClasses = [
  {
    key: "proposalClass",
    label: "Proposal Class",
    type: "select",
    map: proposalClassMap,
    options: proposalClassOptions,
  },
  {
    key: "dispatchClass",
    label: "Dispatch Class",
    type: "select",
    map: dispatchClassMap,
    options: dispatchClassOptions,
  },
];

// ==============================
// 7) AGENCY DISPATCH SUB CLASS
// ==============================
// No fields removed. Just updated "options" to use our unified array object.
export const agencyDispatchSubClass = {
  key: "dispatchSubClass",
  label: "Dispatch Sub Class",
  type: "select",
  map: dispatchSubClassMap,
  options: unifiedSubClassOptions,
};

// The rest remain the same
export const agencyAddressFields = [
  { key: "addressCareOf", label: "Address Care Of", type: "text" },
  { key: "address", label: "Address Line 1", type: "text" },
  { key: "addressTwo", label: "Address Line 2", type: "text" },
  { key: "city", label: "City", type: "text" },
  { key: "state", label: "State", type: "text", length: 2 },
  { key: "zip", label: "Zip", type: "text", length: 5 },
];

export const agencyContactFields = [
  { key: "contact", label: "Contact", type: "text" },
  { key: "fax", label: "Fax", type: "text" },
  { key: "phone", label: "Phone", type: "text" },
  { key: "phone2", label: "Phone 2", type: "text" },
];

// ==============================
// 8) DEFAULT FORM DATA
// ==============================
export const agencyDefaultFormData = {
  agencyId: null,
  agencyName: "",
  agencyType: 1,
  trackTest: false,
  trackViolation: false,
  useNYCViolations: false,
  violationsList: "",
  proposalClass: null,
  dispatchClass: null,
  dispatchSubClass: null,
  addressCareOf: "",
  address: "",
  addressTwo: "",
  city: "",
  state: "",
  zip: "",
  contact: "",
  fax: "",
  phone: "",
  phone2: "",
};

// If you also have test data:
export const agencyTestFormData = {
  agencyId: null,
  label: "",
  description: "",
  frequency: "N/A",
  sequence: 0,
};

export const testFrequencyOptions = [
  { label: "N/A", value: "N/A" },
  { label: "Semi-Monthly", value: "Semi-Monthly" },
  { label: "Semi-Annually", value: "Semi-Annually" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Annual", value: "Annual" },
  { label: "6 Years", value: "6 Years" },
  { label: "5 Years", value: "5 Years" },
  { label: "4 Years", value: "4 Years" },
  { label: "3 Years", value: "3 Years" },
  { label: "2.5 Years", value: "2.5 Years" },
  { label: "2 Years", value: "2 Years" },
];

export const agencyTestFields = [
  { key: "label", label: "Label", type: "text" },
  { key: "description", label: "Description", type: "text" },
  {
    key: "frequency",
    label: "Frequency",
    type: "select",
    options: testFrequencyOptions,
  },
  { key: "sequence", label: "Sequence", type: "number", min: 0 },
];

export const testDetailsFields = [
  {
    key: "testId",
    label: "Test ID",
    type: "text",
    readOnly: true,
  },
  {
    key: "label",
    label: "Label",
    type: "text",
  },
  {
    key: "description",
    label: "Description",
    type: "text",
  },
  {
    key: "frequency",
    label: "Frequency",
    type: "select",
    options: [
      { value: "Daily", label: "Daily" },
      { value: "Weekly", label: "Weekly" },
      { value: "Monthly", label: "Monthly" },
      { value: "Annual", label: "Annual" },
      { value: "5 Years", label: "5 Years" },
    ],
  },
  {
    key: "sequence",
    label: "Sequence",
    type: "number",
  },
];
